import { authDefault } from './default/authDefault';
import { flowDefault } from './default/flowDefault';
import { modalsDefault } from './default/modalsDefault';
export const appDefaultReducer = {
    authReducer: authDefault, //persinstent not to be in black list if settings should persist
    flowReducer: flowDefault,
    modalsReducer: modalsDefault,
};
